// Mock data for dashboard components

// Organization Cards
export const organizationData = [
    {
        id: 'org1',
        name: 'Bella Vista',
        location: 'Downtown Plaza',
        type: 'Premium',
        rating: 4.8,
        venues: 2,
        staff: 24,
        customers: 1250,
        status: 'active'
    },
    {
        id: 'org2',
        name: 'Ocean Breeze',
        location: 'Marina District',
        type: 'Standard',
        rating: 4.6,
        venues: 0,
        staff: 18,
        customers: 850,
        status: 'active'
    },
    {
        id: 'org3',
        name: 'Mountain View Cafe',
        location: 'Hillside Avenue',
        type: 'Premium',
        rating: 4.9,
        venues: 1,
        staff: 31,
        customers: 1780,
        status: 'expiring'
    },
    {
        id: 'org4',
        name: 'Urban Eats',
        location: 'Business District',
        type: 'Standard',
        rating: 4.3,
        venues: 5,
        staff: 12,
        customers: 3200,
        status: 'underperforming'
    }
];

// Subscription Plan Chart
export const subscriptionData = {
    basic: 24,
    professional: 36,
    enterprise: 18,
    totalOrganizations: 78,
    monthlyRevenue: '$42,500',
    professionalPercentage: 49
};

// Revenue Chart
export const revenueData = {
    monthly: [
        { month: 'Jan', value: 45000 },
        { month: 'Feb', value: 50000 },
        { month: 'Mar', value: 48000 },
        { month: 'Apr', value: 45000 },
        { month: 'May', value: 55000 },
        { month: 'Jun', value: 60000 },
        { month: 'Jul', value: 65000 },
        { month: 'Aug', value: 70000 },
        { month: 'Sep', value: 75000 },
        { month: 'Oct', value: 68000 },
        { month: 'Nov', value: 90000 },
        { month: 'Dec', value: 98000 }
    ],
    totalRevenue: '$819,000',
    yearlyGrowth: '+5.5%',
    avgMonthly: '$68,250'
};

// Quick Actions
export const quickActions = [
    {
        id: 'action1',
        title: 'Add New Organization',
        icon: 'pi pi-plus',
        description: 'Register a new organization to the platform',
        route: '/organization/add',
        color: '#2196F3'
    },
    {
        id: 'action2',
        title: 'Add Staff Member',
        icon: 'pi pi-user-plus',
        description: 'Invite new staff to existing organization',
        route: '/staff/add',
        color: '#4CAF50'
    },
    {
        id: 'action3',
        title: 'Export Reports',
        icon: 'pi pi-file-export',
        description: 'Download analytics and usage reports',
        route: '/reports/export',
        color: '#9C27B0'
    },
    {
        id: 'action4',
        title: 'Review System Alerts',
        icon: 'pi pi-exclamation-triangle',
        description: 'Check critical system notifications',
        route: '/alerts',
        color: '#F44336',
        badge: 'Urgent',
        badgeType: 'danger' as 'danger'
    },
    {
        id: 'action5',
        title: 'Process Renewals',
        icon: 'pi pi-sync',
        description: 'Handle subscription renewals',
        route: '/subscriptions/renew',
        color: '#FF9800'
    }
];

// Recent Activity
export const recentActivities = [
    // Today activities
    {
        id: 'activity1',
        type: 'staff',
        title: 'New staff member added',
        description: 'John Smith joined as head chef',
        location: 'Downtown Bistro',
        timestamp: '5m',
        period: 'Today',
        user: { name: 'John Smith' },
        status: 'info'
    },
    {
        id: 'activity2',
        type: 'security',
        title: 'Security alert resolved',
        description: 'Failed login attempts detected and blocked',
        location: 'Seaside Grill',
        timestamp: '15m',
        period: 'Today',
        user: { name: 'Security System' },
        status: 'warning'
    },
    {
        id: 'activity3',
        type: 'organization',
        title: 'New organization onboarded',
        description: 'Metro Cafe successfully set up',
        location: 'Metro Café',
        timestamp: '1h',
        period: 'Today',
        user: { name: 'System' },
        status: 'success'
    },
    {
        id: 'activity4',
        type: 'system',
        title: 'System maintenance completed',
        description: 'Database optimization finished',
        location: 'System',
        timestamp: '3h',
        period: 'Today',
        user: { name: 'System Admin' },
        status: 'success'
    },
    // This Week activities
    {
        id: 'activity5',
        type: 'performance',
        title: 'Performance issue detected',
        description: 'High response times in payment processing',
        location: 'Urban Kitchen',
        timestamp: '1d',
        period: 'This Week',
        user: { name: 'System Monitor' },
        status: 'error'
    },
    {
        id: 'activity6',
        type: 'staff',
        title: 'Bulk staff import completed',
        description: '15 new team members added',
        location: 'Pizza Palace',
        timestamp: '2d',
        period: 'This Week',
        user: { name: 'HR System' },
        status: 'info'
    },
    {
        id: 'activity7',
        type: 'subscription',
        title: 'Organization subscription upgraded',
        description: 'Burger Barn upgraded to Enterprise plan',
        location: 'Burger Barn',
        timestamp: '3d',
        period: 'This Week',
        user: { name: 'Billing System' },
        status: 'info'
    },
    {
        id: 'activity8',
        type: 'venue',
        title: 'Venue settings updated',
        description: 'Operating hours changed for weekend',
        location: 'Cafe Milano',
        timestamp: '4d',
        period: 'This Week',
        user: { name: 'Amanda Rodriguez' },
        status: 'info'
    }
];
